import PropTypes from 'prop-types';
import styles from './FJStyleItem.module.less';
import classNames from 'classnames';
import { useState } from 'react';
import ReloadIcon from '../../../assets/svg/reload.svg?react';
import FJUtil from '../../../util/FJUtil';
import FJLoading from '../../../common/components/FJLoading/FJLoading.jsx';

const FJStyleItem = props => {
    const { imgSrc, onClick, className, selected } = props;
    const [stateImgUrl, setStateImgUrl] = useState(imgSrc);
    const [stateIsLoadError, setStateIsLoadError] = useState(false);
    // 正在应用该样式
    const [applying, setApplying] = useState(false);
    /**
     * @private
     */
    const _refresh = e => {
        e.stopPropagation();
        setStateIsLoadError(false);
        setStateImgUrl(FJUtil.getReloadNewUrl(imgSrc));
    };
    const _sourceLoaded = () => {
        setStateIsLoadError(false);
    };

    const _onClick = () => {
        if (stateIsLoadError) return;
        setApplying(true);
        if (onClick)
            onClick(() => {
                setApplying(false);
            });
    };

    const _sourceError = () => {
        setStateIsLoadError(true);
    };
    return (
        <div className={classNames(styles.container, className)} onClick={_onClick}>
            <div className={classNames(styles.img_box)}>
                {/*<div className={styles.in_border}></div>*/}
                <img
                    src={stateImgUrl}
                    className={styles.img}
                    onLoad={_sourceLoaded}
                    onError={_sourceError}
                    style={{ opacity: stateIsLoadError ? 0 : 1 }}
                    loading='lazy'
                />
                {selected && applying && (
                    <div className={styles.apply}>
                        <FJLoading style={{ width: 16, height: 16 }} />
                    </div>
                )}
                {stateIsLoadError && (
                    <div className={styles.reload}>
                        <ReloadIcon onClick={_refresh} />
                    </div>
                )}
            </div>
        </div>
    );
};
FJStyleItem.propTypes = {
    imgSrc: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
};
export default FJStyleItem;
